var React = require('react');

function CloseCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000","stroke":"#000","d":"M18.71 11.17 16 13.88l-2.71-2.71a1.5 1.5 0 0 0-2.12 0 1.5 1.5 0 0 0 0 2.11L13.88 16l-2.71 2.71a1.5 1.5 0 0 0 0 2.12 1.49 1.49 0 0 0 2.12 0L16 18.12l2.71 2.71a1.49 1.49 0 0 0 2.12 0 1.5 1.5 0 0 0 0-2.12L18.13 16l2.7-2.71a1.5 1.5 0 0 0 0-2.12 1.5 1.5 0 0 0-2.12 0ZM3.17 16C3.17 8.93 8.93 3.17 16 3.17S28.83 8.93 28.83 16 23.07 28.83 16 28.83A12.86 12.86 0 0 1 3.17 16Z"}));
}

CloseCircle.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = CloseCircle;

CloseCircle.default = CloseCircle;
